export const testAttributes = {
    TIMETOREAD_MAIN_CONTAINER: 'time_to_read_container'
}

export const defaultAttributes = {
    MIN_READ_LABEL: 'Min. Read',
    TIME_LABEL: '0',
}